// extracted by mini-css-extract-plugin
module.exports = {"root":"empty_root__2rRcx","image":"empty_image__3uq05","title":"empty_title__3weAO","content":"empty_content__1TAuS"};